import { render, staticRenderFns } from "./PlantDataCard.vue?vue&type=template&id=3d6b0b0e&scoped=true&"
import script from "./PlantDataCard.vue?vue&type=script&lang=ts&"
export * from "./PlantDataCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d6b0b0e",
  null
  
)

export default component.exports